import {IAugmentedJQuery} from "angular";

/** scroller slik at angitt element er i senter av vinduet*/
export function scrollTilSenter(element: IAugmentedJQuery) {
    if (element.length == 0) return;
    element[0].scrollIntoView({block: 'center', behavior: 'smooth'});
}

export function scrollTilNærmestAvToppBunn(element: IAugmentedJQuery) {
    if (element.length == 0) return;
    element[0].scrollIntoView({block: 'nearest', behavior: 'smooth'});
}

/** scroller slik at toppen av element kommer nærmest toppen av scroll-kontainer */
export function scrollTilTopp(element: IAugmentedJQuery) {
    if (element.length == 0) return;
    element[0].scrollIntoView({block: 'start', behavior: 'smooth'});
}

/** scroller slik at bunnen av element kommer nærmest bunn av scroll-kontainer */
export function scrollTilBunn(element: IAugmentedJQuery) {
    if (element.length == 0) return;
    element[0].scrollIntoView({block: 'end', behavior: 'smooth'});
}
